<div class="border-t">
  <div class="p-sm pb-0">
    <ng-content></ng-content>
  </div>
</div>
